export default __webpack_public_path__ + "static/media/portal.4d91c1fd.png";